import React from 'react';

// Our global theme context with default values
export const ThemeContext = React.createContext({
  themeMode: 'dark',
  setThemeMode: () => {},
});

// Theme provider component with state
const ThemeProvider = (props) => {
  const [themeMode, setThemeMode] = React.useState('Грн');
  const value = { themeMode, setThemeMode };

  return (
    <ThemeContext.Provider value={value}>
      {props.children}
    </ThemeContext.Provider>
  );
};

const wrapperThemeProvider = ({ element }) => (
  <ThemeProvider>{element}</ThemeProvider>
);

// Exports a ThemeProvider wrapper
// export default ({ element }) => <ThemeProvider>{element}</ThemeProvider>;
export default wrapperThemeProvider;
